import React from 'react'
import { MainContainer } from '../../components/Contents/Contents.element';
import PageHeader from '../../layout/PageHeader';
import LabelText from '../../ui/LabelText';
import './style.css'
import PageNotFoundIcon from '../../assets/icons/PageNotFoundIcon.svg'

const PageNotFound = () => {

  return (
     <MainContainer  className={'main-container player-detail-page'}>
            <PageHeader title='Page not found'  />
            <div className='page-notfound-container'>
                <div className='page-notfound-content'>
                    <div className='page-notfound-icon'>
                        <img src={PageNotFoundIcon} width={54} height={54}/>
                    </div>
                    <LabelText className='page-notfound-text'>The page you are 
                    looking for doesn’t exist.</LabelText>
                </div>
            </div>
    </MainContainer>
  )
}

export default PageNotFound